// Simplified: Custom fields are now flattened to top-level
export function buildUpdatePayload(field: string, value: unknown) {
  return { [field]: value }
}
